/**
 * Slide toggle an element.
 * @param {class name} parentElement  The wraping element of both the button element and the toggle element. Used for specific targeting of elements.
 * @param {class name} buttonElement  The element that will be clicked to trigger the toggle effect.
 * @param {class name} toggleElement  The element that will be toggled.
 */
function SlideToggleElement(parentElement, buttonElement, toggleElement) {
	var parent 	= $(parentElement);
	var button 	= parent.find(buttonElement);
	var element = parent.find(toggleElement);

	button.on('click', function(){
		element.slideToggle();
	});
}

function toggleActive(toggleActiveElement) {
	$(toggleActiveElement).on('click', function() {
		$(this).toggleClass('active');
	});

}

function eventStopPropagation(element, event) {
    $(element).on(event, function(e){
        e.stopPropagation();
    });
}

$(document).ready(function() {

	if ($('.ArticlePage').length) {
		toggleActive('.share-label');
		eventStopPropagation('.bubble-wrapper', 'click');
	}
});


// WEBPACK FOOTER //
// ./site/js/components/toggle-element.js